document.addEventListener('DOMContentLoaded', () => {
  const funnel = (eventName, detail = {}) => {
    const payload = {
      event: eventName,
      event_id: `nt-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      brand: 'Naughty Tops',
      source: 'theme_hook',
      timestamp: new Date().toISOString(),
      ...detail
    };

    window.dispatchEvent(new CustomEvent('naughtytops:funnel', { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    return payload;
  };

  window.NaughtyTopsFunnel = { emit: funnel };

  document.querySelectorAll('[data-product-root]').forEach((root, rootIndex) => {
    const json = root.querySelector('[data-product-json]');
    if (!json) return;

    const variants = JSON.parse(json.textContent);
    const comboJson = root.querySelector('[data-combo-json]');
    const comboVariants = comboJson ? JSON.parse(comboJson.textContent) : [];
    const comboLink = root.querySelector('[data-combo-link]');
    const crewCopyJson = root.querySelector('[data-crew-link-copy]');
    const crewCopy = crewCopyJson ? JSON.parse(crewCopyJson.textContent) : null;
    const comboHeading = root.querySelector('[data-combo-heading]');
    const comboDescription = root.querySelector('[data-combo-description]');
    const comboNote = root.querySelector('[data-combo-note]');
    const pairContents = root.querySelector('[data-pair-contents]');
    const selects = Array.from(root.querySelectorAll('.nt-native-select[data-option-index]')).sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));
    const idInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-price]');
    const compare = root.querySelector('[data-compare]');
    const form = root.querySelector('[data-product-form]');
    const primaryButton = root.querySelector('[data-add-button]');
    const primaryLabel = root.querySelector('[data-add-label]');
    const hero = root.closest('[data-nt-hero]');
    const possibleBar = hero?.nextElementSibling;
    const mobileBar = possibleBar?.matches('[data-mobile-buy-bar]') ? possibleBar : document.querySelector('[data-mobile-buy-bar]');
    const stickyButton = mobileBar?.querySelector('[data-sticky-submit]');
    const currency = root.dataset.currency || 'USD';
    const money = (cents) => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);

    root.querySelectorAll('[data-option-group]').forEach((group) => {
      const select = root.querySelector(`.nt-native-select[data-option-index="${group.dataset.optionIndex}"]`);
      const buttons = Array.from(group.querySelectorAll('[data-option-button]'));
      if (select && buttons.length && !buttons.some((button) => button.dataset.optionValue === select.value)) {
        select.value = buttons[0].dataset.optionValue;
      }
    });

    const currentValues = () => selects.map((select) => select.value);
    const currentVariant = () => {
      const values = currentValues();
      return variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    };

    const optionValue = (name) => {
      const select = selects.find((item) => (item.dataset.optionName || '').toLowerCase() === name.toLowerCase());
      return select?.value || '';
    };

    const updateVariant = () => {
      const variant = currentVariant();
      if (!variant) return null;

      idInput.value = variant.id;
      price.textContent = money(variant.price);
      compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
      primaryButton.disabled = !variant.available;
      primaryLabel.textContent = variant.available ? `Add to cart · ${money(variant.price)}` : 'Sold out';

      root.querySelectorAll('[data-option-group]').forEach((group) => {
        const select = root.querySelector(`.nt-native-select[data-option-index="${group.dataset.optionIndex}"]`);
        group.querySelectorAll('[data-option-button]').forEach((button) => {
          const selected = button.dataset.optionValue === select?.value;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });

      if (pairContents) {
        const count = optionValue('Pairs').split(' ')[0];
        pairContents.textContent = pairContents.dataset.contentsTemplate.replaceAll('__COUNT__', count).replace('__COLOR__', optionValue('Color'));
      }
      if (comboLink) {
        const design = root.dataset.productHandle === 'og-squirter' ? 'og' : root.dataset.productHandle === 'spray-daddy-male-novelty-spray-top' ? 'sd' : null;
        const pack = optionValue('Pack');
        const crew = design && ['5', '10'].includes(pack) && crewCopy;
        const pairedVariant = comboVariants.find(candidate => candidate.options[0] === optionValue('Color'));
        if (crew) {
          comboLink.href = `${comboLink.dataset.comboUrl}?offer=${design}-${pack}&color=${encodeURIComponent(optionValue('Color'))}`;
          comboLink.textContent = `${pack === '5' ? crewCopy.six : crewCopy.twelve} · ${money(variant.price)}`;
          if (comboHeading) comboHeading.textContent = comboHeading.dataset.crewHeading;
          if (comboDescription) comboDescription.textContent = crewCopy[`${design}-${pack}`];
          if (comboNote) comboNote.textContent = comboNote.dataset.crewNote;
        } else if (pairedVariant) {
          comboLink.href = `${comboLink.dataset.comboUrl}?variant=${pairedVariant.id}`;
          comboLink.textContent = `${comboLink.dataset.comboLabel} · ${money(pairedVariant.price)}`;
          if (comboHeading) comboHeading.textContent = comboHeading.dataset.pairHeading;
          if (comboDescription) comboDescription.textContent = comboDescription.dataset.pairDescription;
          if (comboNote) comboNote.textContent = comboNote.dataset.pairNote;
        }
      }
      if (mobileBar) {
        mobileBar.querySelector('[data-mobile-price]').textContent = money(variant.price);
        mobileBar.querySelector('[data-mobile-pack]').textContent = optionValue('Pairs') || `${optionValue('Pack')} pack`;
        mobileBar.querySelector('[data-mobile-color]').textContent = optionValue('Color');
      }
      if (stickyButton) stickyButton.disabled = !variant.available;
      return variant;
    };

    root.querySelectorAll('[data-option-button]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-option-group]');
        const select = root.querySelector(`.nt-native-select[data-option-index="${group.dataset.optionIndex}"]`);
        if (!select) return;

        select.value = button.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        const variant = currentVariant();

        if (['Pack', 'Pairs'].includes(group.dataset.optionName) && variant) {
          funnel('pack_selected', {
            product_id: root.dataset.productId,
            product_handle: root.dataset.productHandle,
            variant_id: String(variant.id),
            pack: button.dataset.optionValue,
            price: variant.price / 100,
            currency
          });
        }
      });
    });

    selects.forEach((select) => select.addEventListener('change', updateVariant));

    form?.addEventListener('submit', (event) => {
      if (root.dataset.submitting === 'true') {
        event.preventDefault();
        return;
      }

      const variant = currentVariant();
      if (!variant || !variant.available) {
        event.preventDefault();
        return;
      }

      root.dataset.submitting = 'true';
      primaryButton.disabled = true;
      if (stickyButton) stickyButton.disabled = true;
      funnel('add_to_cart', {
        product_id: root.dataset.productId,
        product_handle: root.dataset.productHandle,
        variant_id: String(variant.id),
        pack: optionValue('Pairs') || optionValue('Pack'),
        color: optionValue('Color'),
        price: variant.price / 100,
        currency,
        quantity: 1
      });
    });

    stickyButton?.addEventListener('click', () => {
      if (root.dataset.submitting === 'true' || primaryButton.disabled) return;
      primaryButton.click();
    });

    if (mobileBar && primaryButton && 'IntersectionObserver' in window) {
      let primaryHasBeenVisible = false;
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) primaryHasBeenVisible = true;
        const hasScrolledPast = entry.boundingClientRect.bottom <= 0;
        const show = primaryHasBeenVisible && !entry.isIntersecting && hasScrolledPast;
        mobileBar.classList.toggle('is-visible', show);
        mobileBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }, { threshold: 0.05 });
      observer.observe(primaryButton);
    }

    const initialVariant = updateVariant();
    if (rootIndex === 0 && initialVariant) {
      funnel('product_view', {
        product_id: root.dataset.productId,
        product_handle: root.dataset.productHandle,
        variant_id: String(initialVariant.id),
        pack: optionValue('Pairs') || optionValue('Pack'),
        color: optionValue('Color'),
        price: initialVariant.price / 100,
        currency
      });
    }
  });

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (submitter.dataset.ntTracked === 'true') return;
    submitter.dataset.ntTracked = 'true';
    funnel('checkout_started', {
      cart_items: document.querySelectorAll('.cart-item').length,
      currency: 'USD'
    });
  });
});

if (!customElements.get('product-media-gallery')) {
  customElements.define('product-media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-gallery-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-gallery-dot]'));
      if (!this.viewport || this.slides.length < 2) return;

      this.index = 0;
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.goTo(this.index - 1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.goTo(this.index + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

      let ticking = false;
      this.viewport.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const width = this.viewport.clientWidth || 1;
          this.setActive(Math.round(this.viewport.scrollLeft / width));
          ticking = false;
        });
      }, { passive: true });

      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.slides[0]?.querySelector('video')?.pause();
      }
    }

    goTo(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.pauseInactiveMedia(next);
      this.viewport.scrollTo({ left: this.viewport.clientWidth * next, behavior: 'smooth' });
      this.setActive(next);
    }

    setActive(index) {
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      if (next !== this.index) this.pauseInactiveMedia(next);
      this.index = next;
      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    pauseInactiveMedia(activeIndex) {
      this.slides.forEach((slide, index) => {
        slide.querySelectorAll('video').forEach((video) => {
          if (index === activeIndex && video.hasAttribute('autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }
  });
}

